/**
 * Generic string replace that we want to apply to all outputs
 */
export const stringReplaceOverrides = {
    Macao: "Macau",
};
